
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/baike/[short_name]",
      function () {
        return require("private-next-pages/baike/[short_name]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/baike/[short_name]"])
      });
    }
  